import { useEffect, useRef } from 'react'

declare global {
  interface Window {
    AWIN?: {
      Tracking?: {
        Sale?: {
          amount?: number
          channel?: string
          orderRef?: string
          parts?: string
          currency?: string
          voucher?: string
          test?: number
        }
        run?: () => void
      }
    }
  }
}

type AwinConversionProps = {
  advertiserId: string
  totalAmount: number
  channel: string
  orderReference: string
  commissionGroupCode: string
  currencyCode: string
  voucherCode?: string
  isTest?: boolean
}

export default function AwinConversion(props: AwinConversionProps) {
  const hasRun = useRef(false)

  const fallbackConversionPixelSrc =
    `https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=${encodeURIComponent(
      props.advertiserId,
    )}` +
    `&amount=${encodeURIComponent(props.totalAmount)}` +
    `&ch=${encodeURIComponent(props.channel)}` +
    `&parts=${encodeURIComponent(
      `${props.commissionGroupCode}:${props.totalAmount}`,
    )}` +
    `&ref=${encodeURIComponent(props.orderReference)}` +
    `&cr=${encodeURIComponent(props.currencyCode)}` +
    (props.voucherCode ? `&vc=${encodeURIComponent(props.voucherCode)}` : '') +
    `&testmode=${encodeURIComponent(props.isTest ? '1' : '0')}`

  useEffect(() => {
    if (hasRun.current) {
      return
    }
    hasRun.current = true

    try {
      if (
        typeof window !== 'undefined' &&
        typeof window.AWIN !== 'undefined' &&
        typeof window.AWIN.Tracking !== 'undefined'
      ) {
        window.AWIN.Tracking.Sale = {}
        window.AWIN.Tracking.Sale.amount = props.totalAmount
        window.AWIN.Tracking.Sale.channel = props.channel
        window.AWIN.Tracking.Sale.orderRef = props.orderReference
        window.AWIN.Tracking.Sale.parts = `${props.commissionGroupCode}:${props.totalAmount}`
        window.AWIN.Tracking.Sale.currency = props.currencyCode

        if (props.voucherCode) {
          window.AWIN.Tracking.Sale.voucher = props.voucherCode
        }

        window.AWIN.Tracking.Sale.test = props?.isTest ? 1 : 0

        if (typeof window.AWIN.Tracking.run === 'function') {
          window.AWIN.Tracking.run()
        }
      }
    } catch (e) {
      // no-op
    }
  }, [])

  return (
    <img
      src={fallbackConversionPixelSrc}
      alt=""
      aria-hidden="true"
      className="absolute h-0 w-0 border-0 opacity-0"
    />
  )
}
